module.exports = __webpack_public_path__ + "static/media/logo-white - Copy.d22a835d.png";